module.exports = __webpack_public_path__ + "static/media/chair-booked.b46d469c.png";